import { useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

const gullCry = (ctx, out, when) => {
  const o = ctx.createOscillator();
  const g = ctx.createGain();
  const bp = ctx.createBiquadFilter();
  o.type = "sawtooth";
  bp.type = "bandpass";
  bp.frequency.value = 1150;
  bp.Q.value = 2.2;
  o.frequency.setValueAtTime(1450, when);
  o.frequency.exponentialRampToValueAtTime(820, when + 0.32);
  g.gain.setValueAtTime(0.0001, when);
  g.gain.linearRampToValueAtTime(0.014, when + 0.06);
  g.gain.exponentialRampToValueAtTime(0.0001, when + 0.42);
  o.connect(bp).connect(g).connect(out);
  o.start(when);
  o.stop(when + 0.5);
};

export const SoundToggle = () => {
  const [on, setOn] = useState(false);
  const audio = useRef(null);

  const start = () => {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const len = ctx.sampleRate * 4;
    const buf = ctx.createBuffer(1, len, ctx.sampleRate);
    const d = buf.getChannelData(0);
    let last = 0;
    for (let i = 0; i < len; i++) {
      const white = Math.random() * 2 - 1;
      last = (last + 0.02 * white) / 1.02;
      d[i] = last * 3.2;
    }
    const src = ctx.createBufferSource();
    src.buffer = buf;
    src.loop = true;
    const lp = ctx.createBiquadFilter();
    lp.type = "lowpass";
    lp.frequency.value = 480;
    const g = ctx.createGain();
    g.gain.value = 0.05;
    const lfo = ctx.createOscillator();
    lfo.frequency.value = 0.09;
    const lfoGain = ctx.createGain();
    lfoGain.gain.value = 0.028;
    lfo.connect(lfoGain).connect(g.gain);
    src.connect(lp).connect(g).connect(ctx.destination);
    src.start();
    lfo.start();

    const gullOut = ctx.createGain();
    gullOut.gain.value = 0.8;
    gullOut.connect(ctx.destination);
    const scheduleGull = () => {
      if (!audio.current) return;
      const t = ctx.currentTime + 0.05;
      gullCry(ctx, gullOut, t);
      if (Math.random() > 0.45) gullCry(ctx, gullOut, t + 0.5);
      audio.current.gullTimer = setTimeout(scheduleGull, 3500 + Math.random() * 5500);
    };
    const gullTimer = setTimeout(scheduleGull, 1200);

    audio.current = { ctx, src, lfo, gullTimer };
  };

  const stop = () => {
    if (!audio.current) return;
    clearTimeout(audio.current.gullTimer);
    audio.current.src.stop();
    audio.current.lfo.stop();
    audio.current.ctx.close();
    audio.current = null;
  };

  const toggle = () => {
    if (on) stop();
    else start();
    setOn(!on);
  };

  return (
    <button
      data-testid="sound-toggle"
      onClick={toggle}
      title={on ? "Wycisz fale" : "Włącz szum morza"}
      className={`btn-toon fixed bottom-5 left-5 z-50 flex h-12 w-12 items-center justify-center ${on ? "bg-[#e5b83b]" : "bg-[#f4f1ea]"} text-[#0a0a0a]`}
    >
      {on ? <Volume2 size={20} /> : <VolumeX size={20} />}
    </button>
  );
};
